import { cloneElement } from "react";
import Container from "@/components/shared/Container";
import type { ReactNode, ReactElement } from "react";
import type { CommonProps } from "@/@types/common";

interface SimpleProps extends CommonProps {
  content?: ReactNode;
}

const Simple = ({ children }: SimpleProps) => {
  return (
    <div className="h-full bg-white dark:bg-gray-800 min-h-screen">
      <Container className="flex flex-col flex-auto items-center justify-center min-w-0
      md:max-w-full md:pl-2 md:pr-2
      max-w-xl h-full">
        {
          // <div className="min-w-[320px] md:min-w-[400px] max-w-[400px]">
        }
        <div className={"w-full"}>
          {children}
        </div>
      </Container>
    </div>
  );
};

export default Simple;
